import type {EmailMakerSectorVisibilityCtx} from '../../right-panel-registry.types';

/** Gates AI prompt rows (button/text rewrite, wrapper redesign) on the editor's AI text-generation flag. */
export function isAiTextEnabled(ctx: EmailMakerSectorVisibilityCtx): boolean {
  return ctx.store.isEmailEditorAiTextGenerationEnabled;
}
